// Band-related socket actions
import { formatBand } from "../../services/controllers/helperFunctions";

const sharedModule = require("../../shared.js").default;
let { socket } = sharedModule;

export const createBandActions = (store) => {
  return {
    // BANDS
    addOrUpdateBandData(value) {
      const { ID } = value;

      if (ID == store.currentlyLoggedInBand?.ID) {
        store.setCurrentlyLoggedInBand(value);
      }

      const objectKeys = Object.keys(value);
      if (!store.currentBand) {
        store.currentBand = value;
        this.addBandSubscription(ID);
      } else if (store.currentBand.ID === value.ID) {
        for (const key of objectKeys) {
          store.currentBand[key] = value[key];
        }
      } else {
        store.currentBand = value;
        this.addBandSubscription(ID);
      }
    },

    addBandSubscription(ID) {
      if (store.bandSubscription) {
        socket.off(store.bandSubscription);
      }
      const idStr = `BAND-${ID}`;
      store.bandSubscription = idStr;
      socket.on(idStr, (data) => {
        this.addOrUpdateBandData(formatBand(data));
      });
    },

    // BRANDING CONFIGS
    addOrUpdateBrandingConfigData(value) {
      const { bandId } = value;
      if (!store.currentBrandingConfig) {
        store.currentBrandingConfig = value;
        this.addBrandingConfigSubscription(bandId);
      } else if (store.currentBrandingConfig.bandId === bandId) {
        store.currentBrandingConfig = value;
      } else {
        store.currentBrandingConfig = value;
        this.addBrandingConfigSubscription(bandId);
      }
    },

    addBrandingConfigSubscription(bandId) {
      if (store.brandingConfigSubscription) {
        socket.off(store.brandingConfigSubscription);
      }
      const idStr = `BRANDING-CONFIG-${bandId}`;
      store.brandingConfigSubscription = idStr;
      socket.on(idStr, (data) => {
        this.addOrUpdateBrandingConfigData(data);
      });
    },
  };
};
